import store from '@store/store'

const beforeEach = (to, from, next) => {
  if ((from.name === 'reachout' && to.name !== 'user') ||
      (from.name === 'user' && to.name !== 'reachout')) {
    store.commit('searchExpert/clearCache');
  }
};

export default beforeEach;
